<template>
    <footer class="footer" v-if="false">
        <div class="text-center">
            <p class="text-muted">Copyright &copy; Studio Metatron Ltd.</p>
        </div>
    </footer>
</template>
<script>
export default {
  data() {
    return {};
  }
};
</script>

<style scoped>
footer {
  margin: 50px 0;
}
.footer {
  position: fixed;
  bottom: 0 !important;
  width: 100%;
  height: 60px;
  background-color: #1f4e79;
  z-index: 1000 !important;
  margin: 0px;
}
.footer > .container {
  padding-right: 15px;
  padding-left: 15px;
}
.text-muted {
  margin: 20px 0;
  color: #fff;
}
.container {
  padding-top: 10px;
  padding-bottom: 70px;
}
</style>



// WEBPACK FOOTER //
// Footer.vue?15eff98d